import type { Middleware } from 'openapi-fetch';

import { parseRetryAfter, toApiError } from '../errors';

/*
 * Error normalization middleware (spec §3.3, §4.3).
 * Any non-OK response is parsed as Problem Details and thrown as an ApiError
 * with the request URL stamped on. Throwing here means openapi-fetch surfaces
 * it through `error`/rejection and TanStack Query's cache handlers see a real
 * ApiError, not a bare Response.
 */
export const errorMiddleware: Middleware = {
  async onResponse({ request, response }) {
    if (response.ok) return response;

    let body: unknown = undefined;
    const contentType = response.headers.get('content-type') ?? '';
    if (contentType.includes('json')) {
      try {
        body = await response.clone().json();
      } catch {
        body = undefined;
      }
    }

    const retryAfter = parseRetryAfter(response.headers.get('retry-after'));
    throw toApiError(response.status, request.url, body, retryAfter);
  },
};
